import React from 'react';
import Layout from './Layout';
import Contact from './pages/Contact';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import SinglePlayerGame from './components/singleForm';
import MultiPlayerGame from './components/multiForm';
import BrowseGame from './pages/BrowseGame';
import OtpLogin from './pages/auth/login';
import Register from './pages/auth/Sign';
import RedirectPage from './pages/redirect';
import { Toaster } from 'react-hot-toast';
import Profile from './pages/profile';
import ForgetPassword from './pages/auth/Forget';

const App = () => {
  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <Routes>
        <Route path="/" element={<Layout />} >
          <Route index element={<Home />} />
          <Route path='/singlePlayerGame' element={<SinglePlayerGame />} />
          <Route path='/multiPlayerGame' element={<MultiPlayerGame />} />
          <Route path="/browseGame" element={<BrowseGame />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/profile" element={<Profile />} />
        </Route>
        <Route path="/redirectPage" element={<RedirectPage />} />
        <Route path="/Login" element={<OtpLogin />} />
        <Route path='/forget-password' element={<ForgetPassword />} />
        <Route path="/Register" element={<Register />} />

      </Routes>
    </>
  );
};

export default App;
